<template>
  <builder-modal
    v-if="current"
    :key="current.modalId"
    :rule="current"
    @shown="markShown"
    @close="close"
    @cta="clickButton"
  />
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import { isKnownRoute } from '../actions'
import { configureModalBuilder, useModalBuilder } from '../useModalBuilder'
import BuilderModal from './BuilderModal.vue'

const store = useStore()
const router = useRouter()
const { current, load, markShown, close, clickButton } = useModalBuilder()

configureModalBuilder({
  isKnownRoute: path => isKnownRoute(router, path),
  navigate: path => { router.push(path) }
})

// Вход, автологин, смена аккаунта — перечитываем список; выход — очищаем.
// flush: 'sync' — загрузка стартует сразу, до триггеров страниц, и не зависит от очереди
// рендера: упавшее обновление чужого компонента не должно съесть смену пользователя.
const userId = computed<number | null>(() => store.getters['user/user']?.id ?? null)
watch(userId, id => { load(id) }, { immediate: true, flush: 'sync' })
</script>
